module.exports = __webpack_public_path__ + "files/b7a844145472f9f7d579d8d3aa71c3e3.png";